module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-11.caa226ca.mp3";